export { TaxComponent, getTaxIdLabels } from './src/tax-component';
